// Clean and general way to generate dom elements
var createElement = function (type, attributes, content) {
    if (type === void 0) { type = 'div'; }
    var element = document.createElement(type);
    if (attributes && attributes.length) {
        attributes.forEach(function (attribute) {
            element.setAttribute(attribute.type, attribute.value);
        });
    }
    if (content) {
        element.innerHTML = content;
    }
    return element;
};
export default createElement;
